// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5627":"c5765dcc","8570":"a9995bbf"}[chunkId] + ".chunk.css";
};